import * as Yup from "yup";

type DayEntry = { open: string | null; close: string | null; isClosed: boolean };

function parseTextToDay(text?: string): DayEntry {
  if (!text || text.trim().toLowerCase() === "closed") {
    return { open: null, close: null, isClosed: true };
  }
  const match = text.match(/(\d{1,2}:\d{2})\s*[-–]\s*(\d{1,2}:\d{2})/);
  if (match) {
    return { open: match[1], close: match[2], isClosed: false };
  }
  return { open: null, close: null, isClosed: true };
}

export function buildHoursPayload(
  hoursWeekdays?: string,
  hoursSaturday?: string,
  hoursSunday?: string,
  gateHours?: string,
  gateHoursSaturday?: string,
  gateHoursSunday?: string,
) {
  const weekday = parseTextToDay(hoursWeekdays);
  const saturday = parseTextToDay(hoursSaturday);
  const sunday = parseTextToDay(hoursSunday);
  const gateWeekday = parseTextToDay(gateHours || hoursWeekdays);
  const gateSaturday = parseTextToDay(gateHoursSaturday || gateHours || hoursWeekdays);
  const gateSunday = parseTextToDay(gateHoursSunday || gateHours || hoursWeekdays);

  return {
    officeHours: {
      monday: weekday,
      tuesday: weekday,
      wednesday: weekday,
      thursday: weekday,
      friday: weekday,
      saturday,
      sunday,
    },
    gateAccessHours: {
      monday: gateWeekday,
      tuesday: gateWeekday,
      wednesday: gateWeekday,
      thursday: gateWeekday,
      friday: gateWeekday,
      saturday: gateSaturday,
      sunday: gateSunday,
    },
  };
}

export const locationValidationSchema = Yup.object().shape({
  locationName: Yup.string().max(
    100,
    "Location Name must be at most 100 characters",
  ),

  address: Yup.string().max(200, "Address must be at most 200 characters"),

  address2: Yup.string().max(200, "Address 2 must be at most 200 characters"),

  city: Yup.string().max(100, "City must be at most 100 characters"),

  state: Yup.string().max(100, "State must be at most 100 characters"),

  zipCode: Yup.string()
    .matches(/^\d*$/, "Only numbers are allowed")
    .max(5, "Zip Code must be at most 5 digits"),

  email: Yup.string()
    .required("Email is required")
    .email("Invalid email format"),

  phone: Yup.string().matches(/^\+?[0-9\s\-()]{7,20}$/, "Invalid phone number"),

  hoursWeekdays: Yup.string(),

  hoursSaturday: Yup.string(),

  hoursSunday: Yup.string(),

  gateHours: Yup.string(),

  gateHoursSaturday: Yup.string(),

  gateHoursSunday: Yup.string(),

  ownerName: Yup.string()
    .required("Owner Name is required for DocuSign contracts")
    .max(100, "Owner Name must be at most 100 characters"),
});
